import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-stone-100 px-5 py-16 sm:py-20" data-id="element-99" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-100" data-mp="1o5q0yeg183yx">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-orange-600" data-id="element-101" data-mp="222d9zfl9ekl7">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-102" data-mp="1x5mscntt3gxo" />
        </span>
        <h2 className="mt-6 text-xl font-bold uppercase tracking-wide text-stone-900 sm:text-2xl" data-id="element-103" data-mp="19fskyls9akkt">
          Get Your Money Back Or Keep It
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-stone-600" data-id="element-104" data-mp="14dtg17gvbflr">
          7-day no-questions-asked guarantee. If it&apos;s not what you expected
          or doesn&apos;t save you hours of work, we&apos;ll refund you. Just
          email us.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-semibold text-orange-600 underline underline-offset-4 transition-colors hover:text-orange-700" data-id="element-105" data-mp="qmex10myneep">
          Full refund policy
        </a>
      </div>
    </section>;
}